<template>
    <div style="margin:0 -12px;">
        <div class="wrap">
            <div class="container">
                <div class="" style="padding-top:30%;">
                    <div class="row">
                        <div class="col">
                            <div class="text-center" style="font-size:20px;color:#fff;">
                                いいね！を送りました
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="margin-bottom:-20px;">
                        <div class="col-1"></div>
                        <div class="col">
                        </div>
                        <div class="col">
                            <div class="text-center">
                                <img src="/images/gif/good.gif" class="" style="width: 106px;height:auto;">
                            </div>
                        </div>
                        <div class="col">
                        </div>
                        <div class="col-1"></div>
                    </div>
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col d-flex align-items-center">
                            <div class="">
                                <img :src="login_user.icon_url" class="" style="border-radius: 5px;width: 100%;">
                            </div>
                        </div>
                        <div class="col d-flex align-items-center">
                            <div class="text-center">
                                <img src="/images/Group13179.png" class="" style="width: 100%;">
                            </div>
                        </div>
                        <div class="col d-flex align-items-center">
                            <div class="">
                                <img :src="user.icon_url" class="" style="border-radius: 5px;width: 100%;">
                            </div>
                        </div>
                        <div class="col-1"></div>
                    </div>
                    <br>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <div class="d-grid gap-2" style="padding: 0 5px;">
                                <button type="button" class="btn btn-luna"
                                    style="font-size:18px; padding:12px 0;border-color:#fff;"
                                    onclick="window.location.href = '/search';">閉じる</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_page_init: true,
            advertisements: [],
            user: {
                icon_url: '/images/icon_user.png',
            },
            login_user: {
                icon_url: '/images/icon_user.png',
            },
        };
    },
    methods: {
        async getAdvertisements() {
            axios.get("/api/advertisement/get/2")
                .then((response) => {
                    this.advertisements = response.data.advertisements
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/mini/show/" + this.$route.params['uid'])
                .then((response) => {
                    this.user = response.data.user || this.user;
                    this.login_user = response.data.login_user || this.login_user;
                    this.is_page_init = false
                })
                .catch((error)　=> {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchUsers()
                            //this.getAdvertisements()
                            // ローカルストレージ削除
                            localStorage.removeItem("user_list");
                            localStorage.removeItem("area_list");
                            localStorage.removeItem("age_list");
                            localStorage.removeItem("sex_list");
                            localStorage.removeItem("count");
                            localStorage.removeItem("is_next_page");
                            localStorage.removeItem("is_load");
                            localStorage.removeItem("page");
                            localStorage.removeItem("search_word");
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.fetchUsers()
                //this.getAdvertisements()
                // ローカルストレージ削除
                localStorage.removeItem("user_list");
                localStorage.removeItem("area_list");
                localStorage.removeItem("age_list");
                localStorage.removeItem("sex_list");
                localStorage.removeItem("count");
                localStorage.removeItem("is_next_page");
                localStorage.removeItem("is_load");
                localStorage.removeItem("page");
                localStorage.removeItem("search_word");
            }
        }
        else {
            this.fetchUsers()
            //this.getAdvertisements()
            // ローカルストレージ削除
            localStorage.removeItem("user_list");
            localStorage.removeItem("area_list");
            localStorage.removeItem("age_list");
            localStorage.removeItem("sex_list");
            localStorage.removeItem("count");
            localStorage.removeItem("is_next_page");
            localStorage.removeItem("is_load");
            localStorage.removeItem("page");
            localStorage.removeItem("search_word");
        }
    },
}
</script>
<style scoped>
.good-icon-posison {
    background-color: #fff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    padding: 10px 15px;
    font-size: 20px;
    color: #6B4EFF;
    margin: auto
}
</style>
